import { useEffect } from "react";
import { userLoginCheckThunk } from "../modules/userReducer";

const useLoginCheck = (dispatch) => {
  useEffect(() => {
    dispatch(userLoginCheckThunk());
  }, [dispatch]);
};

export default useLoginCheck;
